var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLinkBankIcon = function SvgLinkBankIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.8 0 0 10.8 0 24C0 37.2 10.8 48 24 48C37.2 48 48 37.2 48 24C48 10.8 37.2 0 24 0ZM30.8571 25.7143H25.7143V30.8571C25.7143 31.8857 25.0286 32.5714 24 32.5714C22.9714 32.5714 22.2857 31.8857 22.2857 30.8571V25.7143H17.1429C16.1143 25.7143 15.4286 25.0286 15.4286 24C15.4286 22.9714 16.1143 22.2857 17.1429 22.2857H22.2857V17.1429C22.2857 16.1143 22.9714 15.4286 24 15.4286C25.0286 15.4286 25.7143 16.1143 25.7143 17.1429V22.2857H30.8571C31.8857 22.2857 32.5714 22.9714 32.5714 24C32.5714 25.0286 31.8857 25.7143 30.8571 25.7143Z",
    fill: "#5ECC4D"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkBankIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link-bank-icon.6cb54e30b9c69c0164f5b28edede5c52.svg";